import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import LogowanieService from "../../../../logowanie/LogowanieService";
import BiletyService from "../../biletyApi/BiletyService";


export default class StatusInTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
            statusy: [],
        };
        this.onChangeStatus = this.onChangeStatus.bind(this)
    }

    componentDidMount() {
        this.setState({status: this.props.status})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({status: nextprops.status})
    }


    onChangeStatus(e) {
        if(e.value === -4){
            if(window.confirm("Czy na pewno zmienić na zwrócony?")){
                this.setState({status: e})
                this.props.handleSelectStatus(e)
            }
        }
        else{
            this.setState({status: e})
            this.props.handleSelectStatus(e)
        }

    }

    onClickLoadOptions(e){
        BiletyService.zapytajoDostepneDoZmianyStatusyBiletu(this.props.idBp)
            .then((response)=>{

                let dostepneStatusy= [];

                if(response.data){
                    for(let i=0;i<response.data.length;i++){

                        if(this.props.statusy.find(s=>s.value === response.data[i].stat_poz)){
                            dostepneStatusy.push(this.props.statusy.find(s=>s.value === response.data[i].stat_poz))
                        }

                    }
                }

                this.setState({statusy:dostepneStatusy})
            })
            .catch((err)=>{
                console.log(err)
                this.refs.notificator.error('Nie można pobrać statusów', "", 3000)
            })
    }

    renderStatusBiletu(option) {
        return <div style={{fontWeight: 'bold', color: option.kolor}}><i className={option.ikona} style={{marginRight: '5px'}}></i> {option.label}
        </div>
    }

    sprawdzCzyZablokowac(){
        // zablokować: do opłaty -1, zwrócony -4, nieopłacony -5, płatność zwrócona -6
        // dla zwyklego operatora zablokowac takze skasowany 2

        let czyZablokowac = false;

        if(Boolean(this.state.status)){
            if(this.state.status.value === 2){
                if(!LogowanieService.sprawdzCzyZalogowanyPosiadaRole(["ROLE_ADMIN"])){
                    czyZablokowac = true
                }
            }

            else if(this.state.status.value === -1 || this.state.status.value === -4 || this.state.status.value === -5 || this.state.status.value === -6 ){
                czyZablokowac = true;
            }
        }


        return czyZablokowac;
    }

    render() {

        return (
            <div>
               <TopSelect onChange={this.onChangeStatus}
                          onFocus={()=>this.onClickLoadOptions()}
                           value={this.state.status}
                           options={this.state.statusy}
                           clearable={false}
                           disabled={
                               this.props.disableSelect ?
                                    true
                                        :
                                    this.sprawdzCzyZablokowac()
                           }
                           valueRenderer={this.renderStatusBiletu} optionRenderer={this.renderStatusBiletu}

                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/StatusInTable.js